import { render } from "./ListProgressReportView.vue?vue&type=template&id=245e5629"
import script from "./ListProgressReportView.vue?vue&type=script&lang=js"
export * from "./ListProgressReportView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__